<template>
  <div class="disease-revenue">
    <!-- 标题 -->
    <Title type="普通" title="疾病收入大盘/7天" />
    
    <!-- 图表容器 -->
    <div class="chart-container">
      <div id="diseaseRevenueChart" class="chart"></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import resize from "@/components/Charts/mixins/resize";
import Title from "../title.vue";

export default {
  name: 'RightDiseaseRevenue',
  mixins: [resize],
  components: {
    Title
  },
  data() {
    return {
      chart: null,
      maxValue: 0,
      minValue: 0,
      name: '',
      // 示例数据 - 根据图片中的疾病名称
      diseaseData: []
    }
  },
  mounted() {
    // this.initChart()
    this.loadData()
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    initChart() {
      this.$nextTick(() => {
        const chartDom = document.getElementById('diseaseRevenueChart')
        if (!chartDom) return
        
        this.chart = echarts.init(chartDom, 'dark')
        
        // 构建雷达图指标
        const indicators = this.diseaseData.map(item => ({
          name: item.name,
          max: Number(this.maxValue) // 最大值增加10%作为上限
        }))
        
        // 构建数据值数组
        const values = this.diseaseData.map(item => item.value)
        
        const option = {
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            borderColor: '#74ffbe',
            borderWidth: 1,
            textStyle: {
              color: '#fff',
              fontSize: 14
            }
          },
          radar: {
            shape: 'circle',
            indicator: indicators,
            splitNumber: 3, // 三个同心圆
            splitArea: {
              show: true,
              areaStyle: {
                // 三个同心圆：从内到外 - 橙色、浅蓝色、浅绿色
                color: [
                  'rgba(255, 165, 0, 0.25)',    // 橙色 - 最内层
                  'rgba(173, 216, 230, 0.25)',  // 浅蓝色 - 中间层
                  'rgba(144, 238, 144, 0.25)'   // 浅绿色 - 最外层
                ]
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.15)',
                width: 1,
                type: 'solid'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.2)',
                width: 1
              }
            },
            axisName: {
              color: '#fff',
              fontSize: 12,
              fontWeight: 'normal',
              formatter: (name) => {
                const item = this.diseaseData.find(d => d.name === name)
                if (item) {
                  // 保持原始数值格式，显示两位小数
                  const value = item.value.toLocaleString('zh-CN', { 
                    minimumFractionDigits: 2, 
                    maximumFractionDigits: 2 
                  })
                  return `${name}\n${value}`
                }
                return name
              }
            }
          },
          series: [
            {
              name: '疾病收入',
              type: 'radar',
              data: [
                {
                  value: values,
                  name: '疾病收入',
                  areaStyle: {
                    color: 'rgba(255, 165, 0, 0.5)' // 半透明橙色填充
                  },
                  lineStyle: {
                    color: '#ff8c00', // 稍深的橙色边框
                    width: 2,
                    type: 'solid'
                  },
                  itemStyle: {
                    color: '#fff', // 数据点颜色为白色
                    borderColor: '#ff8c00',
                    borderWidth: 2
                  },
                  label: {
                    show: false // 不在数据点上显示标签，标签在axisName中显示
                  }
                }
              ]
            }
          ]
        }
        
        this.chart.setOption(option)
        
        // 响应式调整
        window.addEventListener('resize', () => {
          if (this.chart) {
            this.chart.resize()
          }
        })
      })
    },
    loadData() {
      // 这里可以调用接口获取疾病收入数据
      this.$http.post(process.env.VUE_APP_API_HOST + "/kcl_pie", {}).then((res) => {
        if (res.data && res.data.data) {
          this.maxValue = res.data.max || 0
          this.minValue = res.data.min|| 0
          this.name = res.data.name || ""
          this.diseaseData = res.data.data|| []
          // 重新初始化图表
          this.initChart()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.disease-revenue {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #fff;
  box-sizing: border-box;

  .chart-container {
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0 10px 0;

    #diseaseRevenueChart {
      width: 100%;
      height: 100%;
      min-height: 200px;
    }
  }
}
</style>

